import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import useAuthStore from '../store/authStore';

const CACHE_KEY = 'hims_pharmacy_drugs_cache';
const CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours

async function getDrugs(token) {
  try {
    const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    if (cached && Date.now() - cached.ts < CACHE_TTL) return cached.data;
  } catch {}

  const r = await axios.get('/api/pharmacy/drugs', { headers: { Authorization: `Bearer ${token}` } });
  const data = r.data || [];
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data })); } catch {}
  return data;
}

export default function MedicineDropdown({ value, onChange, showStock = true, placeholder = 'Search medicine...' }) {
  const [drugs, setDrugs] = useState([]);
  const [query, setQuery] = useState(value || '');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const token = useAuthStore(s => s.token);
  const ref = useRef(null);

  useEffect(() => {
    getDrugs(token).then(setDrugs).catch(() => {});
  }, [token]);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSearch = (q) => {
    setQuery(q);
    if (!q || q.length < 1) { setResults([]); setOpen(false); return; }
    const q2 = q.toLowerCase();
    const matched = drugs.filter(d => d.name.toLowerCase().includes(q2)).slice(0, 20);
    setResults(matched);
    setOpen(matched.length > 0);
  };

  const select = (drug) => {
    setQuery(drug.name);
    setOpen(false);
    setResults([]);
    onChange(drug.name, drug);
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input
        type="text" value={query}
        onChange={e => handleSearch(e.target.value)}
        onFocus={() => query && results.length > 0 && setOpen(true)}
        placeholder={placeholder}
        style={{ width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' }}
      />
      {open && results.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: '#fff',
          border: '1px solid #e5e7eb', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          zIndex: 1000, maxHeight: 220, overflowY: 'auto'
        }}>
          {results.map(d => (
            <div key={d.id} onClick={() => select(d)}
              style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between' }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f9ff'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fff'}
            >
              <div>
                <span style={{ fontSize: 13, fontWeight: 500, color: '#111' }}>{d.name}</span>
                {d.form && <span style={{ fontSize: 11, color: '#9ca3af', marginLeft: 8 }}>{d.form}</span>}
              </div>
              {showStock && (
                <span style={{ fontSize: 12, color: d.quantity > 0 ? '#059669' : '#ef4444', fontWeight: 600 }}>
                  {d.quantity > 0 ? `${d.quantity} in stock` : 'Out of stock'}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
